import { render } from "./Printers.vue?vue&type=template&id=a6d31f1c"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__